import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Calendar, TrendingUp } from "lucide-react";
import { CHIP_COLORS } from "../utils/colors";

const data = [
  { day: "01", consumption: 4200 },
  { day: "02", consumption: 5800 },
  { day: "03", consumption: 6100 },
  { day: "04", consumption: 7200 },
  { day: "05", consumption: 6800 },
  { day: "06", consumption: 7500 },
  { day: "07", consumption: 8200 },
  { day: "08", consumption: 7900 },
  { day: "09", consumption: 8400 },
  { day: "10", consumption: 9100 },
  { day: "11", consumption: 8800 },
  { day: "12", consumption: 9500 },
  { day: "13", consumption: 9200 },
  { day: "14", consumption: 8600 },
  { day: "15", consumption: 9800 },
];

const EnergyConsumptionChart = () => {
  return (
    <div className="bg-card rounded-xl border border-border p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-heading font-semibold text-foreground">
            Energy Consumption Trend
          </h3>
          <p className="text-sm text-muted-foreground mt-0.5">
            Daily consumption in kWh (Last 15 days)
          </p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5 text-sm text-success bg-success/10 px-2.5 py-1 rounded-full">
            <TrendingUp className="w-3.5 h-3.5" />
            <span className="font-medium">+12.5%</span>
          </div>
          <button className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground px-2.5 py-1 rounded-lg hover:bg-secondary transition-colors">
            <Calendar className="w-4 h-4" />
            <span>This Month</span>
          </button>
        </div>
      </div>

      <div className="h-[220px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 5, right: 5, left: -20, bottom: 0 }}
          >
            <defs>
              <linearGradient
                id="consumptionGradient"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop
                  offset="0%"
                  stopColor={CHIP_COLORS.info}
                  stopOpacity={0.3}
                />
                <stop
                  offset="100%"
                  stopColor={CHIP_COLORS.info}
                  stopOpacity={0}
                />
              </linearGradient>
            </defs>
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="hsl(var(--border))"
              vertical={false}
            />
            <XAxis
              dataKey="day"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
              tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "hsl(var(--card))",
                border: "1px solid hsl(var(--border))",
                borderRadius: "8px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
              }}
              labelStyle={{ color: "hsl(var(--foreground))", fontWeight: 600 }}
              formatter={(value: number) => [
                `${value.toLocaleString()} kWh`,
                "Consumption",
              ]}
            />
            <Area
              type="monotone"
              dataKey="consumption"
              stroke={CHIP_COLORS.info}
              strokeWidth={2.5}
              fill="url(#consumptionGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EnergyConsumptionChart;
